/* eslint-disable object-shorthand */
/* eslint-disable key-spacing */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { makeStyles } from  '@mui/styles';
import Button from '@mui/material/Button';
import { removeSnackbar } from '../../redux/actions/alertActions';

let displayed = [];

const useStyles = makeStyles(() => ({
  button: {
    color: 'white',
  },
  root: {
    'z-index': '1',
  },
}));

const Notifier = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const notifications = useSelector((store) => store.alert.notifications || []);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  useEffect(() => {
    notifications.forEach(({
      key, message, options = {}, dismissed = false, redirectAction
    }) => {
      if (dismissed) {
        closeSnackbar(key);
        return;
      }
      const allActions = [];
      allActions.push(<Button
        style={{ color: '#FFFFFF'}}
        className={classes.button}
        size="meddium"
        onClick={() => {
          closeSnackbar(key);
        }}
      >
        Fermer
          </Button>)
      
      if (redirectAction) {
        allActions.push(<Button
          className={classes.button}
          style={{ color: '#FFFFFF'}}
          size="medium"
          onClick={() => { redirectAction.action.fonction(redirectAction.action.param); closeSnackbar(key);}}
        >
          {redirectAction.name}
          </Button>)
      }

      if (displayed.includes(key)) return;
      enqueueSnackbar(message, {
        key,
        ...options,
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        className: classes.root,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        onExited: (event, myKey) => {
          dispatch(removeSnackbar(myKey));
          removeDisplayed(myKey);
        },
        action: (
          <React.Fragment>
            {allActions}
          </React.Fragment>
        ),
      });
      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);

  return null;
};

export default Notifier;
